module.exports = __webpack_public_path__ + "assets/img/Sedan-Gallery-image-3.7bf57ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/picture/Sedan-Gallery/Sedan-Gallery-image-3.jpg
// module id = BdZk
// module chunks = 1